import { Outlet } from "react-router"
import {
	Stack,
	Tabs,
	TabsList,
	TabContent,
	Heading,
	Container,
} from "@sembark-travel/ui-base"
import { NavLink } from "@sembark-travel/ui-router"
import { generatePath } from "../../../../../router-utils"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../../../Auth"

const tabs = [
	{
		label: "Trips",
		to: generatePath("/org/tags/trips"),
	},
]

export default function Layout() {
	return (
		<ForbidUnlessAuthorized permission={PERMISSIONS.MANAGE_TAGS}>
			<Stack gap="4">
				<Container paddingTop="4">
					<Heading>Tags</Heading>
				</Container>
				<Tabs layout="col" gap="6">
					<TabsList>
						{tabs.map((tab) => (
							<NavLink key={tab.to} to={tab.to}>
								{tab.label}
							</NavLink>
						))}
					</TabsList>

					<TabContent>
						<Outlet />
					</TabContent>
				</Tabs>
			</Stack>
		</ForbidUnlessAuthorized>
	)
}
